/**
 * @NOTE
 * @InitialValues  - are equivalent to Types When in Used in Type Script
 */

export const overnightGuestInitalValues = {
  filipinoForeign: { male: 0, female: 0 },
  filipinoNationality: { male: 0, female: 0 },
  unspecifiedResident: { male: 0, female: 0 },
  nonPhResident: [],
  ofwResident: [],
  lengthOfStay: {
    guestExtending: 0,
    noAvailableRooms: 0,
    noOccupiedRooms: 0,
  },
};
